import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cats, setCats] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/blog/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    api.get("/blog", { params: selected ? { category: selected } : {} }).then((r) => setPosts(r.data)).catch(() => {});
  }, [selected]);

  return (
    <>
      <SEO pageKey="blog" title="Blog — SerpNex" description="SEO strategy, rank tracking data, and honest analysis for agencies, freelancers, marketers, and content creators. Updated weekly." canonical="/blog" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12">
        <div className="eyebrow">Blog</div>
        <h1 className="mt-3 h-display text-5xl sm:text-6xl font-bold text-[#0A0D14]">Notes on ranking.</h1>
        <p className="mt-4 text-[17px] text-[#525B6A] max-w-2xl">SEO strategy, rank-tracking data, and honest analysis — for agencies, freelancers, marketers, and creators. No hot takes, no fluff.</p>

        <div className="mt-10 flex flex-wrap gap-2">
          <button data-testid="blog-cat-all" onClick={() => setSelected(null)} className={`pill ${selected === null ? 'pill-accent' : ''}`}>All</button>
          {cats.map((c) => (
            <button key={c.category} data-testid={`blog-cat-${c.category}`} onClick={() => setSelected(c.category)} className={`pill ${selected === c.category ? 'pill-accent' : ''}`}>
              {c.category} <span className="tabular-nums text-[#8A94A6] ml-1">{c.count}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid md:grid-cols-2 gap-6">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug}`} data-testid={`blog-post-${p.slug}`} key={p.slug} className="card-crisp p-8 group hover:border-[#0047FF] transition-colors">
              <div className="text-xs text-[#0047FF] uppercase tracking-wider font-medium">{p.category}</div>
              <div className="mt-3 text-2xl font-display font-semibold text-[#0A0D14] group-hover:text-[#0047FF] transition-colors">{p.title}</div>
              <div className="mt-3 text-[#525B6A] text-[15px] leading-relaxed">{p.excerpt}</div>
              <div className="mt-6 flex items-center justify-between text-xs text-[#8A94A6]">
                <span>{new Date(p.published_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} · {p.author}</span>
                <span className="text-[#0047FF] inline-flex items-center gap-1">Read <ArrowRight className="h-3 w-3" /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
